import React from 'react';
import Grid from '@mui/material/Grid';
import { useT } from '@transifex/react';
import messages from '../../messages';
import * as S from './styles';

const BanksHero = () => {
  const t = useT();

  return (
    <S.BanksHeroWrapper>
      <S.ContainerBankHero>
        <Grid container>
          <Grid item xs={12} md={8}>
            <S.BanksHeroHeading variant="h1">{t(messages.banksHeroHeading)}</S.BanksHeroHeading>
            <S.BanksHeroDescription variant="body1">
              {t(messages.banksHeroDescription)}
            </S.BanksHeroDescription>
          </Grid>
        </Grid>
      </S.ContainerBankHero>
    </S.BanksHeroWrapper>
  );
};

export default BanksHero;
